export default __webpack_public_path__ + "static/CuervoVP-greenScreenjc2-98e611d786af1caa0008ea562c7289b9.jpg";